import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import LoginIcon from '@mui/icons-material/Login';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Logo from "../assets/images/logo.png";
import {AuthResponse, ForgotPassword as forgot_password} from "../apis/Auth";
import {Alert, Snackbar, Theme, useMediaQuery} from "@mui/material";
import {useEffect, useState} from "react";
import Copyright from "../utilities/Copyright";
import background1 from "../assets/images/user_screen_backgrounds/background1.png";
import background2 from "../assets/images/user_screen_backgrounds/background2.png";
import background3 from "../assets/images/user_screen_backgrounds/background3.png";
import background4 from "../assets/images/user_screen_backgrounds/background4.png";
import background5 from "../assets/images/user_screen_backgrounds/background5.png";
import GA4EventSend from "../utilities/GA4EventSend";
import {Helmet} from "react-helmet";


export default function ForgotPassword() {
    const [open, setOpen] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [isClicked, setIsClicked] = useState<boolean>(false);
    const [success, setSuccess] = useState<boolean>(false);
    const [currentImage, setCurrentImage] = useState(background1);
    const [isMdOrUp, setIsMdOrUp] = useState(useMediaQuery((theme: Theme) => theme.breakpoints.up('md')));

    useEffect(() => {
        // Define your images in an array
        const images = [background1, background2, background3, background4, background5];
        // Create an array to store the preloaded images
        const preloadedImages = [];
        // Pre-load the images
        images.forEach((image) => {
            const img = new Image();
            img.src = image;
            preloadedImages.push(img);
        });
        const timer = setInterval(() => {
            setCurrentImage((currentImage) => {
                const currentIndex = images.indexOf(currentImage);
                const nextIndex = (currentIndex + 1) % images.length;
                return images[nextIndex];
            });
        }, 5000); // Change every 5 seconds

        const handleResize = () => {
            setIsMdOrUp(window.innerWidth >= 960);
            clearInterval(timer)
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isMdOrUp]);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        setIsClicked(true);
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const response: AuthResponse = await forgot_password((data.get('email') as string).toLowerCase());
        if(response.succeeded){
            setMessage(response.message);
            setSuccess(true);
            setOpen(true);
        }
        else{
            setMessage(response.message);
            setSuccess(false);
            setOpen(true);
        }
        GA4EventSend("forgot_password", "user_action", "forgot_password", response.statusCode, false);
        setIsClicked(false);
    };

    return (
        <Grid container sx={{height: '100vh'}}>
            <CssBaseline/>
            <Helmet>
                <title>DRBB | Forgot Password</title>
            </Helmet>
            <Snackbar anchorOrigin={{vertical: "top", horizontal:"center"}} open={open} onClose={() => setOpen(false)} autoHideDuration={6000}>
                <Alert elevation={6} severity={success ? "success" : "error"} sx={{ width: '100%' }} variant="filled">
                    {message}
                </Alert>
            </Snackbar>
            <Grid
                item
                xs={false}
                sm={4}
                md={7}
                sx={{
                    transition: 'background-image 2s ease-in-out',
                    backgroundImage: `url(${currentImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: (t) =>
                        t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            />
            <Grid item xs={12} sm={8} md={5} sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                backgroundColor: (t) =>
                    t.palette.mode === 'light' ? t.palette.grey[50] : "#141414",
            }}>
                <Box
                    sx={{
                        my: 8,
                        mx: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <img src={Logo} alt={'DRBB Logo'} height={'200'}/>
                    <Typography variant={isMdOrUp ? "h3": "h5"} sx={{mt: 1}} fontWeight={"bold"} textAlign={"center"}>
                        Send Password Reset Email
                    </Typography>
                    <Box component="form" noValidate onSubmit={handleSubmit} sx={{mt: 1}}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2,
                                backgroundColor: "#486ce7",
                                color: "#ffffff",
                            }}
                            disabled={isClicked}
                        >
                            <Typography variant={"h6"} fontWeight={"bold"} sx={{
                                textTransform: 'none',
                            }}>
                                Send Forgot Password Email
                            </Typography>
                        </Button>
                        <Grid container justifyContent="center">
                            <Button
                                startIcon={<LoginIcon />}
                                href="/signin"
                                sx={{
                                    backgroundColor: "#486ce7",
                                    color: "#ffffff",
                                    ":hover": {
                                        backgroundColor: "#c40000",
                                        color: "#ffffff",
                                    }
                                }}
                            >
                                <Typography variant={"body2"} fontWeight={"bold"} sx={{
                                    textTransform: 'none',
                                }}>
                                    Return To Sign In Screen
                                </Typography>
                            </Button>
                        </Grid>
                        <Copyright sx={{mt: 5}}/>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
}